import React from "react";

const Card = (props) => {
  const { title = "", players = [], color = "lightGreen", secondTeam } = props;
  return (
    <div className="results-col">
      <h3 className={`text-${color}`}>
        {title}
        <span className={`result-count text-${color}`}>{players.length}</span>
      </h3>
      <div>
        <div className="text-light-blue">
          {players.map((word, index) => (
            <p key={index} className="mb-0">
              {word}
              <span className={`p-1 square bg-gradient-${color}`} />
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Card;
